import { SAVED_CHECKOUT_FIELDS } from "../constants"

// What the guest filled in at checkout, kept per guide for the cart it was filled in for, so a reload
// or an expired reservation doesn't make them type it again. Saved as { cartToken, values, promoCode }:
// the SAVED_CHECKOUT_FIELDS and the order's promo code. Never any card details. Another cart's
// details are not used, and they are forgotten once the booking is paid. Storage can be missing or
// blocked (private window, third-party iframe): the details then last for this visit only.
const storageKey = (guideUuid) => `booking_widget_checkout_${guideUuid}`

const pickSavedFields = (values) =>
  Object.fromEntries(SAVED_CHECKOUT_FIELDS.filter((field) => values?.[field] !== undefined).map((field) => [field, values[field]]))

export const readCheckoutDetails = (guideUuid, cartToken) => {
  if (!cartToken) return null
  try {
    const saved = JSON.parse(window.localStorage.getItem(storageKey(guideUuid)) || "null")
    if (saved?.cartToken !== cartToken) return null
    return { values: pickSavedFields(saved.values), promoCode: saved.promoCode || null }
  } catch (error) {
    return null
  }
}

// Merged into what is saved for this cart: { values } (any form values; only the saved fields are
// kept) and/or { promoCode } (null when removed).
export const saveCheckoutDetails = (guideUuid, cartToken, { values, promoCode }) => {
  if (!cartToken) return
  try {
    const saved = readCheckoutDetails(guideUuid, cartToken) || { values: {}, promoCode: null }
    const next = {
      cartToken,
      values: values ? { ...saved.values, ...pickSavedFields(values) } : saved.values,
      promoCode: promoCode === undefined ? saved.promoCode : promoCode
    }
    window.localStorage.setItem(storageKey(guideUuid), JSON.stringify(next))
  } catch (error) {
    // Nothing to do: the details stay in the form for this visit.
  }
}

export const forgetCheckoutDetails = (guideUuid) => {
  try {
    window.localStorage.removeItem(storageKey(guideUuid))
  } catch (error) {
    // Nothing to do.
  }
}
